/** Статические демо-фрагменты интерфейса для онбординг-сторис (ширина 358).
 *  Все данные — захардкоженные константы хэндоффа, не живые
 *  (design_handoff_onboarding/README.md §Визуалы). */
import {
  ArrowUpIcon,
  AchGrinderIcon,
  AchHomeIcon,
  DeckMiniIcon,
  LvlBetIcon,
  LvlCallIcon,
  LvlCheckIcon,
  LvlRaiseIcon,
  LvlStraddleIcon,
  LvlStraddlePlusIcon,
} from './icons';

/* ---------- 1 · Расписание ---------- */

const TOURNAMENTS = [
  { day: '8', dow: 'ЧТ', name: 'Straddle Open', sub: '19:30 · взнос 1 200 ₽', seats: '18/27', pct: 67, cta: true },
  { day: '10', dow: 'СБ', name: 'Deepstack', sub: '18:00 · взнос 1 500 ₽', seats: '22/36', pct: 61, cta: false },
  { day: '13', dow: 'ВТ', name: 'Bounty Hunter', sub: '19:30 · взнос 1 000 ₽', seats: '9/27', pct: 33, cta: false },
];

export function VisualSchedule() {
  return (
    <div className="inx-col">
      {TOURNAMENTS.map((t) => (
        <div className="inx-card inx-tcard" key={t.name}>
          <div className="inx-trow">
            <div className="inx-tdate">
              <div className="num mono">{t.day}</div>
              <div className="dow">{t.dow}</div>
            </div>
            <div className="inx-tdiv" />
            <div className="inx-tbody">
              <div className="inx-ttitle">
                <span className="nm">{t.name}</span>
                <span className="inx-badge-open mono">Открыта</span>
              </div>
              <div className="inx-tsub mono">{t.sub}</div>
              <div className="inx-tseats">
                <div className="bar">
                  <i style={{ width: `${t.pct}%` }} />
                </div>
                <span className="mono">{t.seats}</span>
              </div>
            </div>
          </div>
          {t.cta && (
            <button type="button" className="inx-reg-btn" tabIndex={-1}>
              Записаться
            </button>
          )}
        </div>
      ))}
    </div>
  );
}

/* ---------- 2 · Профиль ---------- */

const STATS = [
  { v: '12', l: 'Игр сыграно' },
  { v: '2', l: 'Лучшее место' },
  { v: '4', l: 'Финальных стола' },
];
const RECENT = [
  { place: 2, gold: true, name: 'Straddle Open', date: '25.09', pts: '+45' },
  { place: 5, gold: false, name: 'Bounty Hunter', date: '18.09', pts: '+12' },
];

export function VisualProfile() {
  return (
    <div className="inx-col inx-col-14">
      <div className="inx-phead">
        <div className="inx-avatar mono" data-theme="dark">
          Н
        </div>
        <div>
          <div className="nm">Никита</div>
          <div className="season mono">Сезон 1</div>
        </div>
      </div>
      <div className="inx-stats">
        {STATS.map((s) => (
          <div className="inx-stat" key={s.l}>
            <div className="v mono">{s.v}</div>
            <div className="l">{s.l}</div>
          </div>
        ))}
      </div>
      <div className="inx-card inx-recent">
        <div className="hdr">Последние игры</div>
        {RECENT.map((r) => (
          <div className="row" key={r.name}>
            <span className={`place mono${r.gold ? ' gold' : ''}`}>{r.place}</span>
            <span className="mid">
              <span className="nm">{r.name}</span>
              <span className="dt mono">{r.date}</span>
            </span>
            <span className="pts mono">{r.pts}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

/* ---------- 3 · Рейтинг ---------- */

const SEASON_ROWS = [
  { rank: 6, name: 'Марат', pts: 212, me: false },
  { rank: 7, name: 'Никита', pts: 198, me: true },
  { rank: 8, name: 'Олег', pts: 191, me: false },
];

export function VisualRating() {
  return (
    <div className="inx-col">
      <div className="inx-card inx-personal">
        <div className="inx-label mono">Личный рейтинг</div>
        <div className="val-row">
          <span className="val mono">1540</span>
          <span className="chip mono">
            <ArrowUpIcon />
            +18
          </span>
        </div>
        <div className="sub">после последней игры</div>
      </div>
      <div className="inx-card inx-season">
        <div className="inx-label mono">Сезонный · Сезон 1</div>
        <div className="list">
          {SEASON_ROWS.map((r) => (
            <div className={`row${r.me ? ' me' : ''}`} key={r.rank}>
              <span className="rank mono">{r.rank}</span>
              <span className="nm">{r.name}</span>
              <span className="pts mono">{r.pts}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

/* ---------- 4 · Достижения (вариант D «Лояльность») ---------- */

const RING_C = 166.5; // 2πr, r=26.5
const RING_OFFSET = 63.3; // 62%

const LEVELS = [
  { nm: 'Чек', pct: '0%', Icon: LvlCheckIcon, state: 'done' },
  { nm: 'Колл', pct: '3%', Icon: LvlCallIcon, state: 'done' },
  { nm: 'Бет', pct: '5%', Icon: LvlBetIcon, state: 'cur' },
  { nm: 'Рейз', pct: '7%', Icon: LvlRaiseIcon, state: 'locked' },
  { nm: 'Straddle', pct: '10%', Icon: LvlStraddleIcon, state: 'locked' },
  { nm: 'Straddle+', pct: '12%', Icon: LvlStraddlePlusIcon, state: 'locked' },
];

export function VisualAchievements() {
  return (
    <div className="inx-col">
      <div className="inx-card inx-loy">
        <div className="inx-medal">
          <svg width="58" height="58" viewBox="0 0 58 58">
            <circle cx="29" cy="29" r="26.5" fill="none" strokeWidth="3" className="trk" />
            <circle
              cx="29"
              cy="29"
              r="26.5"
              fill="none"
              strokeWidth="3"
              strokeLinecap="round"
              className="fill inx-ring-fill"
              strokeDasharray={RING_C}
              strokeDashoffset={RING_OFFSET}
              transform="rotate(-90 29 29)"
            />
          </svg>
          <span className="core">
            <LvlBetIcon size={22} />
          </span>
        </div>
        <div className="inx-loy-body">
          <div className="inx-label mono">Уровень лояльности</div>
          <div className="lvl-row">
            <span className="nm">Бет</span>
            <span className="disc mono">−5%</span>
          </div>
          <div className="prog">
            <div className="bar">
              <i />
            </div>
            <span className="mono">385 / 600</span>
          </div>
          <div className="next">ещё 215 очков до «Рейз»</div>
        </div>
      </div>

      <div className="inx-card inx-levels">
        <div className="hdr">
          <span className="inx-label mono">Уровни</span>
          <span className="note">скидка на всё в клубе</span>
        </div>
        <div className="tiles">
          {LEVELS.map(({ nm, pct, Icon, state }) => (
            <div className={`tile ${state}`} key={nm}>
              <span className="dot">
                <Icon />
              </span>
              <span className="nm">{nm}</span>
              <span className="pct mono">{pct}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="inx-card inx-ach-pts">
        <div className="inx-label mono">Очки за достижения</div>
        <div className="row">
          <span className="medal gold">
            <AchGrinderIcon />
          </span>
          <span className="mid">
            <span className="nm">Гриндер · уровень II</span>
            <span className="dt mono">Получено 25.09</span>
          </span>
          <span className="pts mono inx-pts-pop inx-pts-pop-1">+40</span>
        </div>
        <div className="row brd">
          <span className="medal steel">
            <AchHomeIcon />
          </span>
          <span className="mid">
            <span className="nm">Свой человек</span>
            <span className="dt mono">Получено 25.09</span>
          </span>
          <span className="pts mono inx-pts-pop inx-pts-pop-2">+15</span>
        </div>
      </div>
    </div>
  );
}

/* ---------- 5 · Straddle Pass ---------- */

export function VisualPass() {
  return (
    <div className="inx-col">
      <div className="inx-pass-ink" data-theme="dark">
        <div>
          <div className="brand mono">Straddle Pass</div>
          <div className="season">Сезон 1</div>
        </div>
        <div className="right">
          <div className="l">До конца сезона</div>
          <div className="v mono">23 дня</div>
        </div>
      </div>
      <div className="inx-card inx-track">
        <div className="hdr">
          <span className="inx-label mono free">Бесплатный</span>
          <span />
          <span className="inx-label mono paid">Straddle Pass</span>
        </div>
        {/* ур. 9 */}
        <div className="trow">
          <div className="reward left">
            <span className="box rar-common">
              <DeckMiniIcon size={22} />
            </span>
            <span className="cap">Колода</span>
          </div>
          <span className="lvl mono">9</span>
          <div className="reward right">
            <span className="box rar-rare">
              <span className="inx-mini-ava mono" data-theme="dark">
                Н
              </span>
            </span>
            <span className="cap">Рамка профиля</span>
          </div>
        </div>
        {/* ур. 10 */}
        <div className="trow">
          <div className="reward left" />
          <span className="lvl mono">10</span>
          <div className="reward right">
            <span className="box rar-legend">
              <span className="inx-voucher mono" data-theme="dark">
                1 вход
              </span>
            </span>
            <span className="cap">Бесплатный вход</span>
          </div>
        </div>
        {/* ур. 11 */}
        <div className="trow">
          <div className="reward left">
            <span className="box rar-common">
              <span className="nick">Ник</span>
            </span>
            <span className="cap">Цвет ника</span>
          </div>
          <span className="lvl mono">11</span>
          <div className="reward right">
            <span className="box rar-epic">
              <DeckMiniIcon size={22} />
            </span>
            <span className="cap">Колода</span>
          </div>
        </div>
      </div>
    </div>
  );
}
